import { LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.FeatureReferral1,
  LocationVarKey.FeatureReferral2,
  LocationVarKey.AllowsReferralsInChat,
  LocationVarKey.AfterNavigateReferral,
  LocationVarKey.AfterNavigateReferral1,
  LocationVarKey.AfterNavigateReferral2
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Referral
      </PageHeader>

      <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasReferralProgram, "1")}>
        <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.FeatureReferral1} />
        <TextAreaRow
          {...page}
          marginTop
          label=" Message 2 (Optional)"
          keyName={LocationVarKey.FeatureReferral2}
          enableSwitchVar={LocationVarKey.FeatureReferral2Enabled}
        />
      </Section>
      <SwitchRow {...page} keyName={LocationVarKey.AllowsReferralsInChat} label="Allow users to provide referrals in chat" />

      <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasReferralProgram, "1")}>
        <SwitchRow {...page} keyName={LocationVarKey.AfterNavigateReferral} label="Ask if they want to be navigated to your Referral Program URL" />
        <Section
          {...page}
          hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.AfterNavigateReferral, "1"), IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")])}
        >
          <SectionHeader {...page}> After Navigate</SectionHeader>
          <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.AfterNavigateReferral1} />
          <TextAreaRow
            {...page}
            marginTop
            label=" Message 2 (Optional)"
            keyName={LocationVarKey.AfterNavigateReferral2}
            enableSwitchVar={LocationVarKey.AfterNavigateReferral2Enabled}
          />
        </Section>
      </Section>
    </>
  );
}
